import React, { useEffect } from "react";
import HeroHeader from "../components/Home/HeroHeader";
import ValorSection from "../components/Home/ValorSection";
import ServiceSection from "../components/Home/ServiceSection";
import AliadosSection from "../components/Home/AliadosSection";
import PagoSection from "../components/Home/PagoSection";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "ELÉCTRICA GRM | Material Eléctrico ";
  }, []);

  return (
    <div>
      <HeroHeader />
      <ValorSection />
      <ServiceSection />
      <AliadosSection />
      <PagoSection />
    </div>
  );
};

export default LandingPage;
